import MenuToggle from 'components/MenuToggle';
import Panel from 'components/Panel';
import Text from 'components/Text';
import TopBar from 'components/TopBar';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

const StatisticsLoading: FC = () => {
  const { t } = useTranslation();
  return (
    <>
      <TopBar title={t('Statistics coming up')} left={<MenuToggle toggleType="back" />} />
      <Panel>
        <Text textAlign="center" color="primary">
          {t('Episode Results coming up!')}
        </Text>
      </Panel>
    </>
  );
};

export default StatisticsLoading;
